import React from "react";
import CategoryOfFixedAssetGenericSkeleton from "./CategoryOfFixedAssetGenericSkeleton";

function CategoryOfFixedAssetDetailSkeleton() {
  return (
    <>
      <CategoryOfFixedAssetGenericSkeleton />
    </>
  );
}

export default CategoryOfFixedAssetDetailSkeleton;
